import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_GU: MRT_Localization = {
  language: "gu",
  actions: "ક્રિયાઓ",
  and: "અને",
  cancel: "રદ કરો",
  changeFilterMode: "ફિલ્ટર મોડ બદલો",
  changeSearchMode: "શોધ મોડ બદલો",
  clearFilter: "ફિલ્ટર સાફ કરો",
  clearSearch: "શોધ સાફ કરો",
  clearSelection: "પસંદગી સાફ કરો",
  clearSort: "ક્રમ સાફ કરો",
  clickToCopy: "કોપી કરવા માટે ક્લિક કરો",
  copy: "કોપી",
  collapse: "સંકુચિત કરો",
  collapseAll: "બધા સંકુચિત કરો",
  columnActions: "કૉલમ ક્રિયાઓ",
  copiedToClipboard: "ક્લિપબોર્ડમાં કોપી કર્યું",
  dropToGroupBy: "ગ્રુપ કરવા માટે {column} પર ડ્રોપ કરો",
  edit: "સંપાદન",
  expand: "વિસ્તૃત કરો",
  expandAll: "બધા વિસ્તૃત કરો",
  filterArrIncludes: "સમાવે છે",
  filterArrIncludesAll: "બધા સમાવે છે",
  filterArrIncludesSome: "સમાવે છે",
  filterBetween: "વચ્ચે",
  filterBetweenInclusive: "સમાવેશી વચ્ચે",
  filterByColumn: "{column} દ્વારા ફિલ્ટર કરો",
  filterContains: "સમાવે છે",
  filterEmpty: "ખાલી",
  filterEndsWith: "સાથે સમાપ્ત થાય છે",
  filterEquals: "સમાન",
  filterEqualsString: "સમાન",
  filterFuzzy: "ફઝી",
  filterGreaterThan: "થી મોટું",
  filterGreaterThanOrEqualTo: "થી મોટું અથવા સમાન",
  filterInNumberRange: "વચ્ચે",
  filterIncludesString: "સમાવે છે",
  filterIncludesStringSensitive: "સમાવે છે",
  filterLessThan: "થી નાનું",
  filterLessThanOrEqualTo: "થી નાનું અથવા સમાન",
  filterMode: "ફિલ્ટર મોડ: {filterType}",
  filterNotEmpty: "ખાલી નથી",
  filterNotEquals: "સમાન નથી",
  filterStartsWith: "સાથે શરૂ થાય છે",
  filterWeakEquals: "સમાન",
  filteringByColumn: "{column} દ્વારા ફિલ્ટરિંગ - {filterType} {filterValue}",
  goToFirstPage: "પ્રથમ પૃષ્ઠ પર જાઓ",
  goToLastPage: "છેલ્લા પૃષ્ઠ પર જાઓ",
  goToNextPage: "આગળના પૃષ્ઠ પર જાઓ",
  goToPreviousPage: "પાછલા પૃષ્ઠ પર જાઓ",
  grab: "પકડો",
  groupByColumn: "{column} દ્વારા ગ્રુપ કરો",
  groupedBy: "દ્વારા ગ્રુપ કર્યું ",
  hideAll: "બધા છુપાવો",
  hideColumn: "{column} કૉલમ છુપાવો",
  max: "મહત્તમ",
  min: "લઘુત્તમ",
  move: "સ્થાનાંતરિત કરો",
  noRecordsToDisplay: "દર્શાવવા માટે કોઈ રેકોર્ડ નથી",
  noResultsFound: "કોઈ પરિણામ મળ્યું નથી",
  of: "નું",
  or: "અથવા",
  pin: "પિન કરો",
  pinToLeft: "ડાબી બાજુ પિન કરો",
  pinToRight: "જમણી બાજુ પિન કરો",
  resetColumnSize: "કૉલમ કદ રીસેટ કરો",
  resetOrder: "ક્રમ રીસેટ કરો",
  rowActions: "પંક્તિ ક્રિયાઓ",
  rowNumber: "#",
  rowNumbers: "પંક્તિ નંબરો",
  rowsPerPage: "પ્રતિ પૃષ્ઠ પંક્તિઓ",
  save: "સેવ",
  search: "શોધો",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} માંથી {rowCount} પંક્તિ(ઓ) પસંદ કર્યા",
  select: "પસંદ કરો",
  showAll: "બધા બતાવો",
  showAllColumns: "બધા કૉલમ બતાવો",
  showHideColumns: "કૉલમ બતાવો/છુપાવો",
  showHideFilters: "ફિલ્ટર બતાવો/છુપાવો",
  showHideSearch: "શોધ બતાવો/છુપાવો",
  sortByColumnAsc: "{column} દ્વારા ચડતા ક્રમમાં સૉર્ટ કરો",
  sortByColumnDesc: "{column} દ્વારા ઉતરતા ક્રમમાં સૉર્ટ કરો",
  sortedByColumnAsc: "{column} દ્વારા ચડતા ક્રમમાં સૉર્ટ કર્યું",
  sortedByColumnDesc: "{column} દ્વારા ઉતરતા ક્રમમાં સૉર્ટ કર્યું",
  thenBy: ", પછી ",
  toggleDensity: "ઘનતા ટૉગલ કરો",
  toggleFullScreen: "પૂર્ણ સ્ક્રીન ટૉગલ કરો",
  toggleSelectAll: "બધા પસંદગી ટૉગલ કરો",
  toggleSelectRow: "પંક્તિ પસંદગી ટૉગલ કરો",
  toggleVisibility: "દૃશ્યતા ટૉગલ કરો",
  ungroupByColumn: "{column} દ્વારા ગ્રુપ રદ કરો",
  unpin: "અનપિન કરો",
  unpinAll: "બધા અનપિન કરો",
};
